import { render } from "./cell-payrate.vue?vue&type=template&id=4839c810"
import script from "./cell-payrate.vue?vue&type=script&lang=js"
export * from "./cell-payrate.vue?vue&type=script&lang=js"

import "./cell-payrate.vue?vue&type=style&index=0&id=4839c810&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__